// extracted by mini-css-extract-plugin
export default {"latestBox":"latest_latestBox__585Vn","label":"latest_label__jpBD6","titles":"latest_titles__xuKs0","date":"latest_date__e6zQn"};